import { Button } from '@acpaas-ui/react-components';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchReset } from '../../../actions/fetch.actions';
import { MODALS } from '../../../constants/modals.constants';
import { useForm } from '../../../hooks/useForm.hook';
import { useModal } from '../../../hooks/useModal.hook';
import { toHoursAndMinutes } from '../../../lib/date.utils';
import ContactMomentAddModal from '../../../modals/ContactmomentAddModal';
import ContactMomentDetailModal from '../../../modals/ContactmomentDetailModal';
import { CONTACTMOMENT_STAKEHOLDERS_RESOURCE } from '../../../resources/contactmoments.stakeholders.resource';
import { DOSSIER_CONTACTMOMENTS_RESOURCE } from '../../../resources/dossier.contactmoments.resource';
import StaticTable from '../../core/StaticTable';

const DossierDetailContactMoments = ({
  data,
  attachments,
  isLoadingAttachments,
  onDossierRefetch,
  onAttachmentsRefetch,
  onUpdated
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const contactmomentAddModal = useModal(MODALS.CONTACTMOMENTS_ADD_MODAL);
  const contactmomentDetailModal = useModal(MODALS.CONTACTMOMENTS_DETAIL_MODAL);
  const contactMomentForm = useForm({});

  const recalculateDuration = (contactMomentId, value, field) => {
    if (field !== 'startTime' && field !== 'endTime') {
      return;
    }
    const originalContactMoment = data?.contactMoment?.find((c) => c.id === contactMomentId);
    if (!originalContactMoment) {
      return;
    }
    originalContactMoment[field] = value;
    if (!originalContactMoment?.startTime || !originalContactMoment?.endTime) {
      return;
    }

    const startTime = moment.utc(originalContactMoment.startTime, 'HH:mm');
    const endTime = moment.utc(originalContactMoment.endTime, 'HH:mm');
    const diff = endTime.diff(startTime);
    onUpdated(toHoursAndMinutes(diff), 'duration', 'contactMoment', contactMomentId);
  };

  const handleUpdated = (value, field, path, contactMomentId) => {
    onUpdated(value, field, path, contactMomentId);
    recalculateDuration(contactMomentId, value, field);
    dispatch(fetchReset(DOSSIER_CONTACTMOMENTS_RESOURCE));
  };

  const handleDelete = () => {
    onDossierRefetch();
    dispatch(fetchReset(DOSSIER_CONTACTMOMENTS_RESOURCE));
  };

  const handleContactmomentOpenClick = (data) => {
    contactMomentForm.load(data);
    dispatch(
      fetchReset({
        ...CONTACTMOMENT_STAKEHOLDERS_RESOURCE,
        key: `${CONTACTMOMENT_STAKEHOLDERS_RESOURCE.key}_${data.id}`
      })
    );
    contactmomentDetailModal.onOpen();
  };

  return (
    <div className="spo-o-dossier-contact-moments">
      <StaticTable
        resource={DOSSIER_CONTACTMOMENTS_RESOURCE}
        onRowClick={handleContactmomentOpenClick}
        data={data?.contactMoment}
        actions={[
          <Button
            key="stakeholder-add"
            size="small"
            className="u-margin-right-sm"
            iconRight="ai-add"
            onClick={contactmomentAddModal.onOpen}
          >
            Contactmoment toevoegen
          </Button>
        ]}
        responsive
      />
      {contactmomentAddModal.isOpen && (
        <ContactMomentAddModal
          dossierId={params.id}
          dossierType={data?.type}
          loadingAttachments={isLoadingAttachments}
          {...contactmomentAddModal}
          attachments={attachments}
          dossierSchools={data?.overview?.school ?? []}
          onAdded={onDossierRefetch}
          onAttachmentsRefetch={onAttachmentsRefetch}
        />
      )}
      {contactmomentDetailModal.isOpen && (
        <ContactMomentDetailModal
          {...contactmomentDetailModal}
          onAttachmentsRefetch={onAttachmentsRefetch}
          attachments={attachments}
          loadingAttachments={isLoadingAttachments}
          dossierId={params.id}
          dossierType={data?.type}
          form={contactMomentForm}
          dossierSchools={data?.overview?.school ?? []}
          onUpdated={handleUpdated}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default DossierDetailContactMoments;
